import sunIcon from '../../assets/image/theme-icons/sun-icon.svg';
import moonIcon from '../../assets/image/theme-icons/moon-icon.svg';
import "./lightDarkMode.scss";

const LightDarkModeToggle = ({ mode, toggleMode }) => {

    return (
        <label className="toggle-mode-container">
            <input
                className="toggle-checkbox"
                type="checkbox"
                checked={mode === "dark"}
                onChange={toggleMode}
            />
            <div className="toggle-slot">
                <div className="sun-icon-wrapper" style={{ opacity: mode === "dark" ? 0 : 1 }}>
                    <img src={sunIcon} className="sun-icon" />
                </div>
                <div className="toggle-button"></div>
                <div className="moon-icon-wrapper" style={{ opacity: mode === "dark" ? 1 : 0 }}>
                    <img src={moonIcon} className="moon-icon" />
                </div>
            </div>
        </label>
    );
};

export default LightDarkModeToggle;
